// 수업관리자 프로젝트 진입점
import './bootstrap';
import { createApp, DefineComponent, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import * as Sentry from '@sentry/vue';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';
//import '@/assets/css/tailwind/output.css';
import '@/assets/css/teacher/style.scss';
// import i18n from '@/admin/core/plugins/i18n';

import ApiService from '@/teacher/services/ApiService';
import { createI18n } from 'vue-i18n';
import messages from './lang';
import { setupNavigationHandlers } from '@/utils/inertia';
import { isVueRuntimeError } from '@/utils/sentryFilters';
import { enumMessages } from '@/lang-enum/index';
import { setEnumTranslator } from '@/utils/i18nEnum';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || null;
const VITE_SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local';
const VITE_SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.3;
const i18n = createI18n({
    legacy: false,
    locale: 'ko',
    fallbackLocale: 'ko',
    fallbackWarn: false,
    missingWarn: false,
    messages: {
        ko: {
            ...messages.ko,
            enums: { ...enumMessages.ko },
        },
    },
    warnHtmlMessage: false,
});
window.$t = i18n.global.t;

// 전역에서 사용할 번역 함수 연결
setEnumTranslator(i18n.global.t.bind(i18n.global));
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        // Inertia.js 스크롤 복원 오류 방지를 위한 안전장치
        if (typeof window !== 'undefined' && !window.history.state) {
            window.history.replaceState({ scrollRegions: [] }, '', window.location.href);
        }
        const app = createApp({ render: () => h(App, props) });

        // Sentry 초기화 추가
        if (VITE_SENTRY_DSN) {
            Sentry.init({
                app,
                dsn: VITE_SENTRY_DSN,
                environment: VITE_SENTRY_ENVIRONMENT,
                tracesSampleRate: VITE_SENTRY_TRACES_SAMPLE_RATE,
                beforeSend(event) {
                    // Vue 내부 런타임 오류 필터링 (vnode/DOM 타이밍 이슈)
                    if (isVueRuntimeError(event)) {
                        return null;
                    }

                    if (event.exception && event.exception.values) {
                        const exception = event.exception.values[0];
                        // status code가 포함된 메시지를 확인
                        if (exception.value?.includes('status code 500')) {
                            console.log('exception.value:', exception.value);
                            return null;
                        }
                    }
                    return event;
                },
            });
        }

        setupNavigationHandlers();

        app.use(plugin);
        app.use(ZiggyVue);
        app.use(i18n);

        ApiService.init(app);

        app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
